import { CloseIcon } from 'Assets/icons';
import * as hmiclientbase from 'components/hmilib/hmiclientbase';
import React from 'react';
import { styleCell, styleInput, styleRow, styleTable } from '../../styles';
import { Button } from '@ixyberfree/ixybercomponents';

interface IPropsBindingsElement {
    pIdObject: any;
    closeCB?: Function;
}

export const BindingsElement: React.FC<IPropsBindingsElement> = (props) => {
    let { pIdObject, closeCB } = props;

    let [bindings, setBindings] = React.useState<any[]>([]);

    let [defnewkey, setDefnewkey] = React.useState<string>('');

    React.useEffect(() => {
        UpdateBindings();
    }, []);

    const DeleteRefObject = async (id: string) => {
        await hmiclientbase.SettingsDeleteObject(id);
        UpdateBindings();
    };

    const editName = async (id: string, newvalue: string) => {
        await hmiclientbase.SettingsChangeProperty(id, 'name', newvalue.toUpperCase());
    };

    const editValue = async (id: string, newvalue: string) => {
        await hmiclientbase.SettingsChangeProperty(id, 'Value', newvalue);
    };

    const genTable = () => {
        let arrTr = [];
        for (let key in bindings) {
            arrTr.push(
                <tr key={bindings[key].id} style={styleRow}>
                    <td style={styleCell}>
                        {' '}
                        <input
                            style={styleInput}
                            name={bindings[key].id}
                            defaultValue={bindings[key].name}
                            onBlur={(e: any) => {
                                editName(e.currentTarget.name, e.currentTarget.value);
                            }}
                            onInput={(e) => {}}
                        />
                    </td>
                    <td style={styleCell}>
                        <input
                            style={styleInput}
                            name={bindings[key].id}
                            defaultValue={bindings[key].Value}
                            onBlur={(e) => {
                                editValue(e.currentTarget.name, e.currentTarget.value);
                            }}
                            onInput={(e) => {}}
                        />
                    </td>
                    <td
                        style={styleCell}
                        data-name={bindings[key].id}
                        onClick={(e: any) => DeleteRefObject(e.currentTarget.getAttribute('data-name'))}>
                        <CloseIcon />
                    </td>
                </tr>
            );
        }

        arrTr.push(
            <tr key={'-1'} style={styleRow}>
                <td style={styleCell}>
                    <input
                        style={styleInput}
                        defaultValue={defnewkey}
                        onBlur={(e) => {
                            AddBinding(e.target.value);
                            e.target.value = '';
                        }}
                    />
                </td>
                <td style={styleCell}>
                    <input style={styleInput} disabled />
                </td>
            </tr>
        );
        return arrTr;
    };

    const UpdateBindings = () => {
        hmiclientbase.SettingsGetObjectDto(pIdObject).then((data: any) => {
            setBindings(data.bindinglist);
            setDefnewkey('');
        });
    };

    const AddBinding = async (key: string) => {
        setDefnewkey(key);

        let type = 'iXyberBaseLib.Binding';

        let newBindObj = await hmiclientbase.SettingsCreateObject(key, type, pIdObject, 'New').then((res: any) => {
            return res;
        });

        UpdateBindings();
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }} /*onClick={() => closeCB && closeCB()}*/
        >
            <div
                style={{
                    padding: '1em',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}>
                <div style={{ overflow: 'auto' }}>
                    <table style={styleTable}>
                        <tbody>{genTable()}</tbody>
                    </table>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '1em' }}>
                    <Button text={'Закрыть'} styleType="filled" size="small" onClick={() => closeCB && closeCB()} />
                </div>
            </div>
        </div>
    );
};
